import { GalleryItem } from '../types/gallery';

let galleryCache: GalleryItem[] | null = null;
let fetchPromise: Promise<GalleryItem[]> | null = null;

export function getCachedGalleryItems(): GalleryItem[] | null {
  return galleryCache;
}

export function setCachedGalleryItems(items: GalleryItem[]): void {
  galleryCache = items;
}

export async function fetchGalleryItems(): Promise<GalleryItem[]> {
  if (galleryCache && galleryCache.length > 0) {
    return galleryCache;
  }
  if (fetchPromise) {
    return fetchPromise;
  }

  fetchPromise = fetch('/gallery.json')
    .then((res) => res.json())
    .then((data: GalleryItem[]) => {
      galleryCache = data;
      fetchPromise = null;
      return data;
    })
    .catch((err) => {
      fetchPromise = null;
      throw err;
    });

  return fetchPromise;
}

export function getOptimizedUrl(rawPath: string, targetWidth = 800): string {
  if (!rawPath) return '';

  let fileName = rawPath.split('/').pop() || '';
  fileName = fileName.replace("whippin' since the 80s 👨‍🍳❄️", 'whippin');
  fileName = fileName.replace('ctrl+del', 'ctrldel');

  const encodedFileName = encodeURIComponent(fileName);
  return `https://ik.imagekit.io/schzstrg/tr:w-${targetWidth},q-75/${encodedFileName}`;
}
